import { ref } from "vue";

// [todo]: merge this with other store
export const groupMembers = ref([])